module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"notice_title":"[{brand_name} 积分说明]","new_review_button_label_with_mileage":"撰写评论并最多获得 %{expected_mileage} 元积分","new_review_button_label":"撰写评论","max_mileage":"最多 {0} 积分可获得","no_review_message":"暂无可写的评价。","money":"元"}}')
  delete Component.options._Ctor
}
